import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UploadMediaListItem from "../UploadMediaListItem/UploadMediaListItem";

class UploadMediaList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentListCount: 0, renderingID: 0 };
  }

  componentDidMount() {
    this.recursive(this.state.renderingID);
  }

  recursive(renderingID) {
    setTimeout(() => {
      if (this.state.renderingID !== renderingID) {
        return;
      }

      this.setState({
        currentListCount: this.state.currentListCount + 3
      });

      if (this.state.currentListCount < this.props.uploadIDs.length) {
        this.recursive(renderingID);
      }
    }, 0);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.uploadIDs !== state.prevUploadIDs) {
      return {
        currentListCount: 0,
        renderingID: state.renderingID + 1,
        prevUploadIDs: props.uploadIDs
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.uploadIDs !== prevProps.uploadIDs) {
      this.recursive(this.state.renderingID);
    }
  }

  render() {
    const { uploadIDs } = this.props;

    const renderingFilteredList = uploadIDs.slice(
      0,
      this.state.currentListCount + 1
    );

    return (
      <React.Fragment>
        {renderingFilteredList.map(uploadID => (
          <Row key={uploadID}>
            <Col md="12">
              <UploadMediaListItem uploadID={uploadID} />
            </Col>
          </Row>
        ))}
        <Row className="bottom_row">
          {<Col>Total {uploadIDs.length} audio(s) / video(s)</Col>}
        </Row>
      </React.Fragment>
    );
  }
}

export default UploadMediaList;
